import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './GuestNavigationBar.scss';

import NavigationBar from './NavigationBar';
import NavigationLink from './NavigationLink';

import {GUEST_LINKS} from '../../sources/constants/headerLinks';

export default class GuestNavigationBar extends Component {
    static propTypes = {
        section: PropTypes.string,
        homePageOpened: PropTypes.bool,
    };

    static contextTypes = {
        router: PropTypes.object
    };

    componentWillReceiveProps(nextProps) {
        const {onActivateLandingSection} = this.props;
        const {location} = nextProps;
        if (!location.hash && location.pathname === '/') {
            window.scrollTo(0, 0);
            onActivateLandingSection('home');
        }
    }

    render() {
        return (
            <NavigationBar>
                {GUEST_LINKS.map(this.renderLandingLink)}
            </NavigationBar>
        );
    }

    renderLandingLink = ({id, label, commonLink, path, isExternal}, index) => {
        const {homePageOpened} = this.props;
        const active = this.isActive(path, commonLink);

        return <NavigationLink
            key={index}
            homePageOpened={homePageOpened}
            to={path}
            isExternal={isExternal}
            active={active}
            label={loc(label)}
        />;
    };

    isActive = (path, commonLink) => {
        const {hash, pathname} = this.context.router.location;

        if (commonLink) return pathname === path;
        return hash && `/${hash}` === path;
    };
}



// WEBPACK FOOTER //
// ./src/components/Header/GuestNavigationBar.js